import { useAppSelector } from '../Store/hooks'

export const PermissionCheck = (submodule:string) => {
    const permission = useAppSelector((state) => state?.auth?.permission);
    return permission.some((obj:any) => obj === submodule);
}